import React from 'react';

// The two Material Symbols helpers the organizer panel uses, copied from the
// web app's src/Teacher/Oireachtas/components.jsx. Keep them in step.

// Ensure the Material Symbols font the design uses is loaded once.
export function useMaterialSymbols() {
  React.useEffect(() => {
    const id = 'oir-material-symbols';
    if (document.getElementById(id)) return;
    const l = document.createElement('link');
    l.id = id;
    l.rel = 'stylesheet';
    l.href =
      'https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=block';
    document.head.appendChild(l);
  }, []);
}

export const Msr = ({ children, style }) => (
  <span className="msr" style={style}>
    {children}
  </span>
);
